import { useState } from 'react';

export const FilterSidebar = () => {
  const [sortBy, setSortBy] = useState('relevancia');
  const [departureTimes, setDepartureTimes] = useState<string[]>([]);
  const [amenities, setAmenities] = useState<string[]>([]);
  const [vehicleTypes, setVehicleTypes] = useState<string[]>([]);

  const toggleCheckbox = (value: string, state: string[], setState: (value: string[]) => void) => {
    if (state.includes(value)) {
      setState(state.filter((item) => item !== value));
    } else {
      setState([...state, value]);
    }
  };

  const clearFilters = () => {
    setSortBy('relevancia');
    setDepartureTimes([]);
    setAmenities([]);
    setVehicleTypes([]);
  };

  return (
    <div className="bg-white rounded-[16px] border border-[#E5E7EB] shadow-sm p-6 sticky top-[145px]">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-[#111827]">Filtrar salidas</h3>
        <button
          onClick={clearFilters}
          className="text-sm text-[#FF6A2A] hover:text-[#C2410C] font-medium transition-colors"
        >
          Limpiar filtros
        </button>
      </div>

      {/* Sort Radio Group */}
      <div className="mb-8">
        <h4 className="text-sm font-semibold text-[#111827] mb-4">Ordenar por</h4>
        <div className="space-y-3">
          {[
            { value: 'relevancia', label: 'Relevancia' },
            { value: 'price-asc', label: 'Precio: menor a mayor' },
            { value: 'rating', label: 'Mejor calificado' },
            { value: 'departure-early', label: 'Salida más temprana' },
            { value: 'departure-late', label: 'Salida más tarde' },
          ].map((option) => (
            <label key={option.value} className="flex items-center gap-3 cursor-pointer group">
              <input
                type="radio"
                name="sort"
                value={option.value}
                checked={sortBy === option.value}
                onChange={(e) => setSortBy(e.target.value)}
                className="w-4 h-4 text-[#FF6A2A] border-[#E5E7EB] focus:ring-2 focus:ring-[#FF6A2A] cursor-pointer"
              />
              <span className="text-sm text-[#111827] group-hover:text-[#FF6A2A] transition-colors">
                {option.label}
              </span>
            </label>
          ))}
        </div>
      </div>

      {/* Departure Time Checkboxes */}
      <div className="mb-8 pb-8 border-b border-[#E5E7EB]">
        <h4 className="text-sm font-semibold text-[#111827] mb-4">Horario de salida</h4>
        <div className="space-y-3">
          {[
            { value: 'morning', label: 'Mañana (06:00–12:00)' },
            { value: 'afternoon', label: 'Tarde (12:00–18:00)' },
            { value: 'evening', label: 'Noche (18:00–24:00)' },
          ].map((option) => (
            <label key={option.value} className="flex items-center gap-3 cursor-pointer group">
              <input
                type="checkbox"
                value={option.value}
                checked={departureTimes.includes(option.value)}
                onChange={() => toggleCheckbox(option.value, departureTimes, setDepartureTimes)}
                className="w-4 h-4 text-[#FF6A2A] border-[#E5E7EB] rounded focus:ring-2 focus:ring-[#FF6A2A] cursor-pointer"
              />
              <span className="text-sm text-[#111827] group-hover:text-[#FF6A2A] transition-colors">
                {option.label}
              </span>
            </label>
          ))}
        </div>
      </div>

      {/* Amenities Chips */}
      <div className="mb-8 pb-8 border-b border-[#E5E7EB]">
        <h4 className="text-sm font-semibold text-[#111827] mb-4">Amenidades</h4>
        <div className="flex flex-wrap gap-2">
          {['A/C', 'Wi-Fi', 'Baño', 'USB', 'Asientos reclinables'].map((amenity) => (
            <button
              key={amenity}
              onClick={() => toggleCheckbox(amenity, amenities, setAmenities)}
              className={`px-4 py-2 rounded-[14px] text-sm font-medium border transition-all ${
                amenities.includes(amenity)
                  ? 'bg-[#FF6A2A] text-white border-[#FF6A2A]'
                  : 'bg-white text-[#111827] border-[#E5E7EB] hover:border-[#FF6A2A]'
              }`}
            >
              {amenity}
            </button>
          ))}
        </div>
      </div>

      {/* Vehicle Type Chips */}
      <div>
        <h4 className="text-sm font-semibold text-[#111827] mb-4">Tipo de vehículo</h4>
        <div className="flex flex-wrap gap-2">
          {['Sprinter', 'Urvan', 'Bus'].map((vehicle) => (
            <button
              key={vehicle}
              onClick={() => toggleCheckbox(vehicle, vehicleTypes, setVehicleTypes)}
              className={`px-4 py-2 rounded-[14px] text-sm font-medium border transition-all ${
                vehicleTypes.includes(vehicle)
                  ? 'bg-[#FF6A2A] text-white border-[#FF6A2A]'
                  : 'bg-white text-[#111827] border-[#E5E7EB] hover:border-[#FF6A2A]'
              }`}
            >
              {vehicle}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
